import CurpDocumentFormatPattern from '@/data/usecases/data-format-pattern/curp-document-format-pattern'
import DocumentCnpjFormatPattern from '@/data/usecases/data-format-pattern/document-cnpj-format-pattern'
import DocumentCpfFormatPattern from '@/data/usecases/data-format-pattern/document-cpf-format-pattern'
import GenericDocumentFormatPattern from '@/data/usecases/data-format-pattern/generic-document-format-pattern'
import RgRneFormatPattern from '@/data/usecases/data-format-pattern/rg-rne-format-pattern'
import OptionalDocumentFormatPattern from '@/data/usecases/data-format-pattern/optional-document-format-pattern'
import type { DynamicMaskType } from 'imask'
import DocumentFormatPattern from '../document-format-pattern-model'
import { DocumentModel } from './document-model'
import { i18nTranslationHelper } from '@/i18n'

const t = i18nTranslationHelper.getTEnums

export namespace DocumentType {
  export class Enum {
    static readonly IDENTITY_REGISTRATION = new Enum(
      'IDENTITY_REGISTRATION',
      'registration',
      'RG / RNE',
      false,
      RgRneFormatPattern
    )
    static readonly CPF = new Enum('CPF', 'document', 'CPF', true, DocumentCpfFormatPattern)
    static readonly CNPJ = new Enum('CNPJ', 'document', 'CNPJ', true, DocumentCnpjFormatPattern)
    static readonly CURP = new Enum('CURP', 'document', 'CURP', true, CurpDocumentFormatPattern)
    static readonly CC = new Enum('CC', 'document', 'CC', true, GenericDocumentFormatPattern)
    static readonly CE = new Enum('CE', 'document', 'CE', true, GenericDocumentFormatPattern)
    static readonly PASSPORT = new Enum(
      'PASSPORT',
      'document',
      t('documentType.PASSPORT.title'),
      true,
      GenericDocumentFormatPattern
    )
    static readonly OTHER = new Enum(
      'OTHER',
      'document',
      t('documentType.OTHER.title'),
      true,
      OptionalDocumentFormatPattern
    )

    private constructor(
      public readonly name: string,
      public readonly fieldName: string,
      public readonly title: string,
      public readonly main: boolean,
      public readonly pattern?: DocumentFormatPattern<string | RegExp>
    ) {}

    getDynamicPattern(): DocumentFormatPattern<DynamicMaskType> {
      return this.pattern as unknown as DocumentFormatPattern<DynamicMaskType>
    }

    hide(value: string): string {
      return this.pattern?.hide?.(value) ?? value
    }

    public is(document: DocumentModel): boolean {
      return document.type === this
    }
  }

  export const getValues = (): Enum[] => {
    return Object.values(DocumentType.Enum)
  }

  export const getMainValues = (): Enum[] => {
    return getValues().filter(type => type.main)
  }

  export const getByValue = (value: string | undefined): Enum | undefined => {
    return getValues().find(type => type.name === value)
  }
}
